import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from './index';

interface ProfileState {
  currentMarket: string;
  markets: string[];
  profileInfo: any | null;
}

const initialState: ProfileState = {
  currentMarket: '',
  markets: [],
  profileInfo: null,
};

export const profileSlice = createSlice({
  name: 'profile',
  initialState,
  reducers: {
    setCurrentMarket: (state, action: PayloadAction<string>) => {
      state.currentMarket = action.payload;
    },
    setMarkets: (state, action: PayloadAction<string[]>) => {
      state.markets = action.payload;
    },
    setProfileInfo: (state, action: PayloadAction<any | null>) => {
      state.profileInfo = action.payload;
    },
  },
});

export const { setCurrentMarket, setMarkets, setProfileInfo } = profileSlice.actions;

export const selectCurrentMarket = (state: RootState) => state.profile.currentMarket;
export const selectMarkets = (state: RootState) => state.profile.markets;
export const selectProfileInfo = (state: RootState) => state.profile.profileInfo;

export const profileReducer = profileSlice.reducer;
export default profileReducer;
